import { PayloadAction } from "@reduxjs/toolkit";
import { SessionInfoResponse } from "../../../../orchestrator-api-client";
import { LayoutState } from "../layout.slice.ts";
import { isExternalComparatorChannel } from "../../../../utilities/channel.ts";

export default function initStoreReducer(
  state: LayoutState,
  action: PayloadAction<SessionInfoResponse | undefined>,
) {
  state.hasPartnerLogo = isExternalComparatorChannel(
    action.payload?.loan?.channel || "",
  );
  state.isSessionLoading = false;
  state.isLoading = false;
}
